import type { BonoContent } from '../types/content';

export const bonos: BonoContent[] = [
  {
    number: '01',
    label: 'BONO 01',
    title: 'FICHAS DE PISTA',
    tag: '25 FICHAS COMPACTAS',
    copy: [
      'Elige el objetivo de la sesión, consulta la ficha y llévate la estructura a pista.',
      'Pensadas para consultar desde el móvil o imprimir.'
    ],
    destacado: 'ELIGE → CONSULTA → MONTA',
    imageLabel: 'Fichas de Pista'
  },
  {
    number: '02',
    label: 'BONO 02',
    title: 'RADAR DEL ALUMNO',
    tag: 'DIAGNÓSTICO EXPRESS EN 7 MINUTOS',
    copy: [
      'Un sistema práctico para observar las principales áreas del jugador, detectar prioridades y establecer un punto de partida más claro.'
    ],
    destacado: 'ANTES DE PLANIFICAR, DESCUBRE QUÉ NECESITA REALMENTE EL ALUMNO.',
    imageLabel: 'Radar del Alumno'
  },
  {
    number: '03',
    label: 'BONO 03',
    title: 'SEMÁFORO DE CORRECCIONES RÁPIDAS',
    tag: '50 ERRORES COMUNES',
    copy: [
      'Una guía de consulta para identificar errores frecuentes y convertir explicaciones demasiado largas en indicaciones más concretas y accionables.'
    ],
    destacado: 'MENOS DISCURSO. MÁS CLARIDAD.',
    imageLabel: 'Semáforo de Correcciones'
  },
  {
    number: '04',
    label: 'BONO 04',
    title: 'PLANIFICADOR 30 DÍAS',
    tag: 'TU HOJA DE RUTA',
    copy: [
      'No necesitas intentar aplicar 250 páginas durante el primer fin de semana.',
      'El Planificador 30 Días organiza la implantación de Maestro en Pista progresivamente durante tu primer mes.'
    ],
    destacado: 'UN PASO CADA VEZ. SIN SATURARTE.',
    imageLabel: 'Planificador 30 Días'
  },
  {
    number: '05',
    label: 'BONO 05',
    title: 'VUELTA A PISTA',
    tag: 'ENTRENAMIENTO ADAPTADO',
    copy: [
      'Una guía orientativa para adaptar el entrenamiento ante molestias habituales o durante el regreso progresivo a pista.'
    ],
    destacado: 'UN REGRESO MÁS CONTROLADO A LA PISTA.',
    note: 'Este material tiene finalidad educativa y no sustituye la valoración, diagnóstico o tratamiento de un profesional sanitario.',
    imageLabel: 'Vuelta a Pista'
  }
];
